module.exports = __webpack_public_path__ + "img/category-popular.34ae9a88.png";